/**
 * Used to interact with the parent window when the designer
 * is loaded in an iframe, etc. Javascript on the parent side
 * can intercept these messages and interpret as needed.
 * @type {Object}
 */
/* global Helpers */

export const templateSaving = {
    data () {
        return {
            canvas: null,
            canvasData: [],
            templateName: null
            // savedTemplateUuid: null
        }
    },
    methods: {
        initNewSavedTemplate (callback = null) {
            this.templateName = new Date().getUTCMilliseconds()

            let data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: '{}'
            }

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName)
                this.$store.commit('savedTemplate', this.$store.state.template)
            }

            this.axios.post('templates/saved/create', data)
            .then((response) => {
                this.savedTemplateUuid = response.data.data.id
            })
            .catch((err) => {
                Helpers.errorPop('Error', err.response.data.message)
            })
            if (callback !== null) {
                callback()
            }
        },
        saveAsNewTemplate (callback = null, $event = null) {
            let currentText = null
            if ($event) {
                currentText = $event.target.innerText
                $('.saveButtons').attr('disabled', 'disabled')
                $event.target.innerText = 'Processing, please wait..'
            }
            let templateData = this.extractTemplateData()
            let data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: templateData
            }

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName)
                this.$store.commit('savedTemplate', this.$store.state.template)
            }

            // this.axios.put('templates/saved/' + this.savedTemplateUuid, data)
            this.axios.post('templates/saved/create', data)
            .then((response) => {
                this.setTemplateFiles(response.data.data.data)
                this.setTemplateData(response.data.data)
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled')
                    $event.target.innerText = currentText
                }
            })
            .catch((err) => {
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled')
                    $event.target.innerText = currentText
                }
                Helpers.errorPop('Error', err.response.data.message)
            })
            if (callback !== null) {
                callback()
            }
        },
        deleteSavedTemplate (id) {

        },
        updateExistingTemplate (callback = null, $event = null) {
            let currentText = null
            if ($event) {
                currentText = $event.target.innerText
                $('.saveButtons').attr('disabled', 'disabled')
                $event.target.innerText = 'Processing, please wait..'
            }
            let templateId = this.$store.state.savedTemplate.id
            let templateData = this.extractTemplateData()
            let data = {
                name: this.templateName,
                template_lib_uuid: this.$store.state.template.id,
                data: templateData
            }

            if (this.$store.state.savedTemplate === null) {
                this.$store.commit('templateName', this.templateName)
                this.$store.commit('savedTemplate', this.$store.state.template)
            }

            this.axios.put('templates/saved/' + templateId, data)
            .then((response) => {
                this.setTemplateFiles(response.data.data.data)
                this.setTemplateData(response.data.data)
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled')
                    $event.target.innerText = currentText
                }
            })
            .catch((err) => {
                if (currentText) {
                    $('.saveButtons').removeAttr('disabled')
                    $event.target.innerText = currentText
                }
                Helpers.errorPop('Error', err.response.data.message)
            })
            if (callback !== null) {
                callback()
            }
        },
        extractTemplateData () {
            this.generateImage()
            this.exportData()
            let files = this.$store.state.template.files
            let data = {}
            for (let x in files) {
                if (data[x] === undefined) {
                    data[x] = {}
                    data[x].json = {}
                }

                data[x].name = files[x].name
                data[x].json.objects = files[x].json.objects
                data[x].preview = files[x].preview

                if (files[x].printReady) {
                    data[x].printReady = files[x].printReady
                }
            }

            return JSON.stringify(data)
        },
        injectTemplateData (data) {
            let activeTemplate = this.$store.state.activeTemplate
            let savedTemplateData = data.data

            // Unclip All Masks
            for (let i in this.canvasData) {
                if (this.canvasData[i].clipTo !== null) {
                    this.canvasData[i].clipTo = null
                }
            }

            let template = this.$store.state.template
            let files = template.files
            for (let x in files) {
                if (savedTemplateData[x] !== undefined) {
                    for (let i in savedTemplateData[x].json.objects) {
                        let item = savedTemplateData[x].json.objects[i]
                        if (item.custom !== undefined && item.custom.confirmed !== undefined) {
                            item.custom.confirmed = false
                        }
                    }
                    files[x].json.objects = savedTemplateData[x].json.objects
                }
            }

            template.files = files
            this.$store.commit('template', template)
            this.setTemplateData(data)

            // Reapply All Masks
            this.applyAllMasks()

            this.canvasLoad(activeTemplate)
        },
        setTemplateData (data) {
            this.templateName = data.name
            this.$store.commit('templateName', data.name)
            this.$store.commit('savedTemplate', data)
        },
        setTemplateFiles (data) {
            let template = this.$store.state.template
            let files = template.files

            for (let x in files) {
                files[x].preview = data[x].preview
                if (data[x].printReady) {
                    files[x].printReady = data[x].printReady
                }
            }

            template.files = files
            this.$store.commit('savedTemplate', template)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/templateSaving.js